module.exports = __webpack_public_path__ + "img/home_basketball.a542f0e6.jpg";